<input type="hidden">

<!-- Dropdown toggle -->
<button #overlayOrigin="cdkOverlayOrigin"
        aria-haspopup="listbox"
        cdkOverlayOrigin
        data-bspk="dropdown"
        role="combobox"
        [attr.aria-controls]="menuId"
        [attr.aria-expanded]="panelOpen() || null"
        [attr.aria-label]="ariaLabel()"
        [attr.data-empty]="!value().length || null"
        [attr.data-invalid]="invalid() || null"
        [attr.data-readonly]="readOnly() || null"
        [attr.data-size]="size()"
        [disabled]="disabled() || readOnly()"
        [id]="id()"
        (blur)="handleBlur($event)"
        (click)="toggle()"
>
  <bspk-list-item data-placeholder role="button" [label]="dropdownLabel() || placeholder()" />
  <span data-svg>
    <mat-icon>chevron_right</mat-icon>
  </span>
</button>

<!-- Dropdown Panel -->
<ng-template cdkConnectedOverlay
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             cdkConnectedOverlayHasBackdrop
             [cdkConnectedOverlayOpen]="panelOpen()"
             [cdkConnectedOverlayOrigin]="overlayOrigin"
             (backdropClick)="closePanel()"
             (detach)="closePanel()"
>
  <!-- Dropdown menu -->
  <bspk-menu floating
             [disabled]="disabled()"
             [id]="menuId"
             [isMulti]="isMulti()"
             [itemCount]="itemCount()"
             [items]="options()"
             [selectedValues]="value()"
             [style.width]="menuWidth()"
             (selectedValuesChange)="onChange($event)"
  />
</ng-template>
